import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/product/[slug]/components/ProductDetailPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Chip.tsx");
